<script setup>
import { Inertia } from '@inertiajs/inertia'
import ManageAdminUsersCard from '@/Components/Models/User/ManageAdminUsersCard'
import ConnectXero from '@/Components/Xero/ConnectXero'
import XeroSettingsCard from '@/Components/Xero/XeroSettingsCard'
import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
    /** ManageAdminUsers props */
    adminUsers: {
        type: Object,
        default: () => ({}),
    },
    /** ConnectXero props */
    connected: {
        type: Boolean,
        default: false,
    },
    error: {
        type: Object,
        default: null,
    },
    organisationName: {
        type: String,
        default: null,
    },
    username: {
        type: String,
        default: null,
    },
    authRoute: {
        type: String,
        default: null,
    },
	/** UpdateXeroSettings props */
	xeroSettings: {
		type: Object, // this will actually be an InertiaForm object
		required: true,
	},
})
</script>

<template>
	<ManageAdminUsersCard 
		v-if="auth.isAdmin"
		:admin-users="adminUsers" 
	/>

	<SectionCard 
		title="Connect your Xero account"
		v-if="auth.isAdmin"
	>
		<ConnectXero 
			:connected="connected" 
			:error="error" 
			:organisation-name="organisationName" 
			:username="username" 
			:auth-route="authRoute" 
			v-if="auth.isAdmin"
		/>
		<template #footer>
			<a 
				:href="authRoute"
				data-testid="reconnect-xero-button"
				class="no-child-events no-underline mt-6"
			>
				<Button
					color="blue"
				>
					{{ connected ? "Reconnect to Xero" : "Connect to Xero" }}
				</Button>
			</a>
		</template>
	</SectionCard>
	
	<XeroSettingsCard 
		:xero-settings="xeroSettings"
	/>
</template>